import { useMutation, useQuery } from "@tanstack/react-query";
import { httpClient, ROOT_URL } from "../App";
import { BaseKey } from "node_modules/@refinedev/core/dist";

export const useGetListSendMoney = (params: {
  start: number;
  end: number;
  name?: string;
  status?: string;
  gte?: string;
  lte?: string;
  timeZone?: string;
}) => {
  return useQuery<any>(
    [
      `/api/v1/payment_requests/get-list`,
      params.start,
      params.end,
      params.name,
      params.status,
      params.gte,
      params.lte,
      params.timeZone,
    ],
    async () => getListSendMoney(params)
  );
};

export function getListSendMoney({
  start,
  end,
  name,
  status,
  gte,
  lte,
  timeZone,
}: {
  start: number;
  end: number;
  name?: string;
  status?: string;
  gte?: string;
  lte?: string;
  timeZone?: string;
}) {
  const params = new URLSearchParams();
  params.append("_start", String(start));
  params.append("_end", String(end));
  if (name) params.append("_like", name);
  if (status) params.append("_status", status);
  if (gte) params.append("_gte", gte);
  if (lte) params.append("_lte", lte);
  if (timeZone) params.append("_timeZone", timeZone);
  window.dispatchEvent(new CustomEvent('updateUnreadCounts'))
  return httpClient.get(
    `${ROOT_URL}/api/v1/payment_requests/get-list?${params.toString()}`
  );
}

export const useChangeStatusPaymentRequest = (config = {}) => {
  return useMutation({
    ...config,
    mutationFn: changeStatusPaymentRequest,
  });
};

export function changeStatusPaymentRequest(params: any) {
  const { id, ...bodyUpdate } = params;
  const body = { ...bodyUpdate };
  return httpClient.patch(`${ROOT_URL}/api/v1/payment_requests/${id}`, body);
}

export const useChangeStatusInvoicePayple = (config = {}) => {
  return useMutation({
    ...config,
    mutationFn: changeStatusInvoicePayple,
  });
};

export function changeStatusInvoicePayple(params: {
  id: BaseKey;
  status: string;
}) {
  const body = {
    status: params.status,
    id: params.id,
  };
  return httpClient.patch(`${ROOT_URL}/api/v1/invoice_payables/update`, body);
}

// Exchange Rate API
export function getExchangeRate(params: { from: number; to: number }) {
  const queryParams = new URLSearchParams();
  queryParams.append('_from', String(params.from));
  queryParams.append('_to', String(params.to));
  return httpClient.get(`${ROOT_URL}/api/v1/exchange-rates?${queryParams.toString()}`);
}

export const useGetExchangeRate = (params: { from: number | undefined; to: number | undefined }, config = {}) => {
  return useQuery<any>(
    ['/api/v1/exchange-rates', params.from, params.to],
    async () => getExchangeRate({ from: params.from!, to: params.to! }),
    {
      ...config,
      enabled: !!params.from && !!params.to,
    }
  );
};

// Configuration Fee API
export function getConfigurationFee(currencyId: number) {
  return httpClient.get(`${ROOT_URL}/api/v1/fee-configuration/currency/${currencyId}`);
}

export const useGetConfigurationFee = (config = {}) => {
  return useMutation({
    ...config,
    mutationFn: getConfigurationFee,
  });
};

// Create Send Money API
export function createSendMoney(body: any) {
  return httpClient.post(`${ROOT_URL}/api/v1/payment_requests`, body);
}

export const useCreateSendMoney = (config = {}) => {
  return useMutation({
    ...config,
    mutationFn: createSendMoney,
  });
};

// Available Balance API
export function getAvlBalanceInternal(currencyId: number, userId: number) {
  const queryParams = new URLSearchParams();
  queryParams.append('_userId', String(userId));
  return httpClient.get(`${ROOT_URL}/api/v1/asset-config-groups/${currencyId}/available-balance?${queryParams.toString()}`);
}

export const useGetAvlBalanceInternal = (currencyId: number, userId: number, config = {}) => {
  return useQuery<any>(
    ['/api/v1/asset-config-groups', currencyId, userId],
    async () => getAvlBalanceInternal(currencyId, userId),
    {
      ...config,
      enabled: !!currencyId && !!userId,
    }
  );
};

// Get All Metadata Currency API
export function getAllMetadataCurrency() {
  return httpClient.get(
    `${ROOT_URL}/api/v1/asset-config-groups/get-all?_start=0&_end=100`
  );
}

export const useGetAllMetadataCurrency = (config = {}) => {
  return useQuery<any>(
    ['/api/v1/asset-config-groups/get-all'],
    async () => getAllMetadataCurrency(),
    {
      ...config,
    }
  );
};